import React from 'react';

export const Loading: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="flex space-x-2">
        <div className="w-3 h-3 bg-asai-primary rounded-full loading-dot"></div>
        <div className="w-3 h-3 bg-asai-primary rounded-full loading-dot"></div>
        <div className="w-3 h-3 bg-asai-primary rounded-full loading-dot"></div>
      </div>
    </div>
  );
};

export const LoadingDots: React.FC = () => {
  return (
    <div className="flex space-x-1">
      <div className="w-2 h-2 bg-gray-500 rounded-full loading-dot"></div>
      <div className="w-2 h-2 bg-gray-500 rounded-full loading-dot"></div>
      <div className="w-2 h-2 bg-gray-500 rounded-full loading-dot"></div>
    </div>
  );
};
